import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { authKeys } from '@core/react-query/features/auth'
import { RequestErrorType } from '@core/utils/api-axios-instance'

type Response = { email: string }
export const useCreatePassword = (
  options?: UseMutationOptions<
    Response,
    RequestErrorType,
    RequestTypes['createPassword']
  >,
) => {
  return useMutation({
    mutationFn: (variables) =>
      authKeys.createPassword(variables).queryFn(undefined),
    ...options,
  })
}
